"use client";

import React from "react";
import { AlertCircle, LogOut, PhoneOff } from "lucide-react";

interface SmartfloSessionConflictModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function SmartfloSessionConflictModal({ open, onConfirm, onCancel, isLoading = false }: SmartfloSessionConflictModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-xs p-4 animate-in fade-in duration-200">
      <div className="relative w-full max-w-md overflow-hidden rounded-2xl border border-[var(--border)] bg-[var(--surface)] p-6 shadow-2xl animate-in zoom-in-95 duration-200">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-500/10 text-amber-500 ring-8 ring-amber-500/5">
            <AlertCircle className="h-7 w-7" />
          </div>

          <h3 className="text-lg font-bold text-[var(--text-strong)]">
            Account Active on Another Device
          </h3>

          <p className="mt-2 text-sm text-[var(--text-muted)] leading-relaxed">
            Account already logged in from other device. Do you want to logout from there and login here?
          </p>

          <div className="mt-6 flex w-full flex-col gap-2.5 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={onCancel}
              disabled={isLoading}
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-[var(--border)] bg-[var(--surface-muted)] px-4 py-2.5 text-sm font-semibold text-[var(--text)] transition hover:bg-[var(--surface-subtle)] disabled:opacity-50 sm:w-1/2 cursor-pointer"
            >
              <PhoneOff className="h-4 w-4 text-[var(--text-subtle)]" />
              No (Stay Offline)
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isLoading}
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md transition hover:bg-blue-700 disabled:opacity-50 sm:w-1/2 cursor-pointer"
            >
              {isLoading ? (
                <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
              ) : (
                <LogOut className="h-4 w-4" />
              )}
              Yes (Login Here)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
